<template>
  <div class="main">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>平台岗位管理</el-breadcrumb-item>
      <el-breadcrumb-item>学生投递</el-breadcrumb-item>
    </el-breadcrumb>
     <FindJob />
  </div>
</template>

<script>
import FindJob from "./components/find-job";

export default {
  components: {
    FindJob
  },
  data() {
    return {
      activeName: "0",
      resumesNum: {
        num1: "",
        num4: ""
      }
    };
  },
  mounted() {
    // this.getResumesNum();
  },
  methods: {
    async getResumesNum() {
      let p = await this.$api.studentManage.getResumesNum();
      let num1 = p.data.job;
      let num4 = p.data.faxian;
      this.resumesNum = {
        num1,
        num4
      };
    }
  }
};
</script>

<style lang="scss" scope>
.main {
  position: relative;
  padding: 20px;
  .el-breadcrumb {
    margin-bottom: 20px;
  }
}
</style>